"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockDapiProxyWithOev__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_api3ServerV1",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_dapiNameHash",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_oevBeneficiary",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "api3ServerV1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dapiNameHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "oevBeneficiary",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x60e060405234801561001057600080fd5b506040516101f03803806101f083398101604081905261002f91610068565b6001600160a01b0392831660805260a0919091521660c0526100a4565b80516001600160a01b038116811461006357600080fd5b919050565b60008060006060848603121561007d57600080fd5b6100868461004c565b92506020840151915061009b6040850161004c565b90509250925092565b60805160a05160c0516101206100d0600039600060450152600060bb01526000609501526101206000f3fe6080604052348015600f57600080fd5b5060043610603c5760003560e01c80630e15999d1460415780632d6a744e146091578063dcf8da921460b7575b600080fd5b60677f000000000000000000000000000000000000000000000000000000000000000081565b60405173ffffffffffffffffffffffffffffffffffffffff90911681526020015b60405180910390f35b60677f000000000000000000000000000000000000000000000000000000000000000081565b60dd7f000000000000000000000000000000000000000000000000000000000000000081565b604051908152602001608856fea2646970667358221220fbe4e963932b6f2210632355be55a9c154c23712a8de5b2581eaa80037ebebd864736f6c634300081b0033";
const isSuperArgs = (xs) => xs.length > 1;
class MockDapiProxyWithOev__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_api3ServerV1, _dapiNameHash, _oevBeneficiary, overrides) {
        return super.getDeployTransaction(_api3ServerV1, _dapiNameHash, _oevBeneficiary, overrides || {});
    }
    deploy(_api3ServerV1, _dapiNameHash, _oevBeneficiary, overrides) {
        return super.deploy(_api3ServerV1, _dapiNameHash, _oevBeneficiary, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.MockDapiProxyWithOev__factory = MockDapiProxyWithOev__factory;
//# sourceMappingURL=MockDapiProxyWithOev__factory.js.map